/**
 * WordPress dependencies
 */
import { dispatch } from '@wordpress/data';
import { store as coreStore } from '@wordpress/core-data';

/**
 * Internal dependencies
 */
import { TEAM_MEMBER_ENTITY } from './constants';

const registerTeamMemberEntity = () => {
	const { addEntities } = dispatch( coreStore );
	addEntities( [ TEAM_MEMBER_ENTITY ] );
};

registerTeamMemberEntity();

/**
 * Register blocks.
 */
import './product-collections/services';
import './block-bindings/team-members';
